import styled from 'styled-components'

const StyledMain = styled.div`
  margin: 0px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.09);
  max-height: 93vh;
  overflow-y: hidden;
`

export default StyledMain
